import { Pool_OptionRenderer } from "./Pool_OptionRenderer.js";
import { sortOptions, generateImageURL, calculateStartingPrice, handleSelection } from "./Pool_Utils.js";

class Pool_Shape {
    /**
     * Creates an instance of the Pool_Shape class.
     * @param {Array} poolShapes - Available pool shape options.
     * @param {Object} configurator - Reference to the main PoolConfigurator instance.
     */
    constructor(poolShapes, configurator) {
        this.poolShapes = poolShapes;
        this.configurator = configurator;
        this.container = document.getElementById("step-2-options");
    }

    /**
     * Renders the available pool shapes based on the selected pool style.
     */
    render() {
        const selectedPool = this.configurator.state.selectedPool;
        if (!selectedPool || !selectedPool.variants) return;

        const skimmerPrice = parseFloat(this.configurator.state.selectedSkimmer?.price || 0);
        const compatibleTypes = selectedPool.compatibleLinerTypes;
        const poolHeight = selectedPool.height.replace(/\D/g, "");

        // Generate unique shapes and compute their starting prices
        const shapes = [...new Set(selectedPool.variants.map(v => v.shape))].map(shape => {
            const variantsForShape = selectedPool.variants.filter(v => v.shape === shape);
            const hasPoolVariants = variantsForShape.some(v => v.available);

            const startingPrice = hasPoolVariants
                ? calculateStartingPrice(variantsForShape, this.configurator.steps.liner.linerStyles, compatibleTypes, poolHeight, skimmerPrice)
                : null;

            return {
                id: shape,
                name: shape,
                image: generateImageURL(shape),
                startingPrice,
                stock: hasPoolVariants && startingPrice !== null ? 1 : 0
            };
        });

        this.container.innerHTML = Pool_OptionRenderer.renderOptions(
            sortOptions(shapes),
            "Choose Your Pool Shape",
            (selectedItem) => handleSelection(this.configurator, "pool-shape", selectedItem),
            null,
            "pool-shape"
        );        
    }
}

export { Pool_Shape };
